import QuestionSectionForm from "pages/ManagementPage/questionSection/QuestionSectionForm/QuestionSectionForm";

export default QuestionSectionForm;
